export default "/static/images/19e4c6ba2e81c58065c48e7a15548355.png";